import { render } from "./AppHeaderDropdownMerchant.vue?vue&type=template&id=6912f88b"
import script from "./AppHeaderDropdownMerchant.vue?vue&type=script&lang=js"
export * from "./AppHeaderDropdownMerchant.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__